// extracted by mini-css-extract-plugin
export default {"url":"URL_url__CFJfj","content":"URL_content__kgudi","icon":"URL_icon__bvmgQ","text":"URL_text__-v1Ou","preview":"URL_preview__6XhFw"};